export default __webpack_public_path__ + "assets/icon-take.d6683352.webp";